'use client'

import { useEffect } from 'react'
import { noticeError } from '@/lib/newrelic-browser'

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    noticeError(error, { digest: error.digest ?? '', boundary: 'global' })
  }, [error])

  return (
    <html lang="en">
      <body>
        <div style={{ minHeight: '60vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '1rem', padding: '1.5rem', textAlign: 'center', fontFamily: 'system-ui, sans-serif' }}>
          <h2 style={{ fontSize: '1.25rem', fontWeight: 600 }}>Something went wrong</h2>
          <p style={{ fontSize: '0.875rem', maxWidth: '32rem' }}>
            We hit an unexpected error and the page failed to load. The team has been notified.
          </p>
          <button
            type="button"
            onClick={reset}
            style={{ border: '1px solid #ccc', borderRadius: '0.375rem', padding: '0.5rem 1rem', fontSize: '0.875rem', cursor: 'pointer' }}
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  )
}
